/**
 * InvoiceViewDetails
 *
 * Renders the printable invoice header: company details on the left,
 * document type / number / dates / amount-due on the right. Sub-components
 * live in `InvoiceViewDetails-parts.tsx`.
 */

import { HeaderLeft, HeaderRight } from './InvoiceViewDetails-parts'

import type { Address, Invoice } from '../../../types/billing'

interface InvoiceViewDetailsProps {
  invoice: Invoice
  isVendor: boolean
  isExport: boolean
  docHeading: string
  baseCurrency: string
  sellerAddress: Address | null
  partyBillingAddress: Address | null
}

export function InvoiceViewDetails({
  invoice,
  isVendor,
  isExport,
  docHeading,
  baseCurrency,
  sellerAddress,
  partyBillingAddress,
}: InvoiceViewDetailsProps): JSX.Element {
  return (
    <div className="preview-header">
      <HeaderLeft
        invoice={invoice}
        isVendor={isVendor}
        partyBillingAddress={partyBillingAddress}
        sellerAddress={sellerAddress}
      />
      <HeaderRight
        baseCurrency={baseCurrency}
        docHeading={docHeading}
        invoice={invoice}
        isExport={isExport}
      />
    </div>
  )
}
